/**
 * EntitySection
 *
 * Collapsible section with an icon and heading.
 * Uses native <details>/<summary> for accessible disclosure.
 */

import type { ReactNode } from 'react';
import styles from './EntityPage.module.scss';

interface EntitySectionProps {
  /** Section heading text */
  title: string;
  /** SVG icon component from @bn-apps/design-system-icons */
  icon: ReactNode;
  /** Section body content */
  children: ReactNode;
  /** Whether the section starts expanded (default: true) */
  defaultOpen?: boolean;
  /** Additional class on the wrapper */
  className?: string;
}

const EntitySection = ({
  title,
  icon,
  children,
  defaultOpen = true,
  className,
}: EntitySectionProps): JSX.Element => (
  <details className={`${styles.entitySection} ${className ?? ''}`} open={defaultOpen}>
    <summary className={styles.entitySectionSummary}>
      <span className={styles.entitySectionIcon}>{icon}</span>
      <span className={styles.entitySectionTitle}>{title}</span>
      <span className={styles.entitySectionChevron} aria-hidden="true" />
    </summary>
    <div className={styles.entitySectionBody}>{children}</div>
  </details>
);

export default EntitySection;
